import { createContext, h } from 'preact'; /** @jsx h */
import { useEffect, useRef, useState } from 'preact/hooks';

const NotificationContext = createContext();

function NotificationProvider({ children }) {
    const [notification, setNotification] = useState({
        type: '',
        message: '',
        link: { text: '', url: '' },
        isOpen: false
    });

    const notificationTimeoutRef = useRef(null);

    const showNotification = (type, message, linkText, linkUrl, timer) => {
        setNotification({ type, message, link: { text: linkText, url: linkUrl }, isOpen: true });

        if (notificationTimeoutRef.current) {
            clearTimeout(notificationTimeoutRef.current);
        }

        if (timer !== undefined && timer !== 0) {
            notificationTimeoutRef.current = setTimeout(() => {
                setNotification({ ...notification, isOpen: false });
            }, timer * 1000);
        }
    };

    const clearNotificationTimeout = () => {
        if (notificationTimeoutRef.current) {
            clearTimeout(notificationTimeoutRef.current);
        }
    };

    const restartNotificationTimeout = timer => {
        notificationTimeoutRef.current = setTimeout(() => {
            setNotification({ ...notification, isOpen: false });
        }, timer * 1000 || 3000);
    };

    const closeNotification = () => {
        setNotification({ ...notification, isOpen: false });
        clearTimeout(notificationTimeoutRef.current);
    };

    useEffect(() => {
        return () => {
            if (notificationTimeoutRef.current) {
                clearTimeout(notificationTimeoutRef.current);
            }
        };
    }, []);

    return (
        <NotificationContext.Provider
            value={{
                notification,
                showNotification,
                clearNotificationTimeout,
                restartNotificationTimeout,
                closeNotification
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
}

export { NotificationContext, NotificationProvider };
